/*
  Search query minimum length
*/

export const SEARCH_QUERY_MIN_LENGTH = 3

/*
  Phone number format
*/

export const PHONE_NUMBER_FORMAT = '+7 (999) 999-99-99'

/*
  Debounce (ms) for address suggestion requests
*/

export const ADDRESS_SUGGESTION_DEBOUNCE_TIMEOUT = 500

/*
  How many digits we use (must be synced with backend settings!)
*/

export const AUTH_SMS_CODE_DIGITS = 4

/*
  Delay for cart flash messages
*/

export const CART_NOTIFICATION_TIMEOUT = 2000

/*
  Debounce (ms) for search requests
*/

export const SEARCH_INPUT_DEBOUNCE_TIMEOUT = 500

/*
  Debounce (ms) for search customers requests
*/

export const CUSTOMER_SEARCH_DEBOUNCE_TIMEOUT = 500

/*
  How many orders show per page
*/

export const ORDERS_PER_PAGE_LIMIT = 10

/**
 * Customer frontend URL
 */

export const CUSTOMER_FRONTEND_URL =
  (import.meta.env.VITE_APP_CUSTOMER_FRONTEND_URL as string) || 'https://hive-software.com'
